export default "__VITE_ASSET__3RAjVrp1__"